import React from "react";
import FinalStep from "../../../components/yourAssets/SI/FinalStep";

const SharesOfInheritance = () => {
  return (
    <div>
      <FinalStep />
    </div>
  );
};

export default SharesOfInheritance;
